import React, { Component } from "react";
import { Carousel, Button, MenuItem, PageHeader, ListGroup, ListGroupItem, Col, Row } from "react-bootstrap";
import config                       from "../../config";
import DropdownHome                 from "../../components/dropdown/DropdownHome";
import { FontAwesomeIcon }          from '@fortawesome/react-fontawesome'
import { signOutUser }              from "../../libs/awsLib";
import uniqueId                     from 'lodash/uniqueId';
import CardProgressBar              from "../../components/program/CardProgressBar";
import AthleteMarketplace           from "../../components/marketplace/AthleteMarketplace";
import program_category_black_fade  from '../../images/utils/program_category_black_fade.png';
import ModalMktplcInfo              from "../../components/modal/ModalMktplcInfo";
import LoaderButton                 from "../../components/LoaderButton";
import { WhiteLabel }               from "../../utils/WhiteLabelProps";
import { invokeGetListAllPrograms,
         invokeGetListAllMarketplacePrograms,
         invokeSetAthleteMarketplaceSubscriber } from "../../utils/AwsInvoke";
import { Steps, Hints }                          from "intro.js-react"; // js code for welcome tour

import "intro.js/introjs.css"; // css for welcome tour
import "../../css/program/Dashboard.css";


var white_label = WhiteLabel();
const MainColor = white_label.company_primary_btn_color;
const cover_image_custom_url  = white_label.aws_custom_athlete_assets_dashboard_url;
const cover_image_general_url = white_label.aws_general_athlete_assets_url;
const mktplc_prog_id          = white_label.mktplc_prog_id;
const LinkColor = "#178ad3";

const posture_health_company_id = "69c4ac91-69b7-11ea-b027-a3b6eeba595f";
const klu_user_id               = "29f05c50-b2ab-11e8-9392-cdc36ab27e5a";
const jc_user_id                = "520b3da0-b2a0-11e8-aead-efe3b60561d4";

/*const steps = [
  {
    element: '.selector1',
    intro: 'test 1',
    position: 'right',
    tooltipClass: 'myTooltipClass',
    highlightClass: 'myHighlightClass',
  },
  {
    element: '.selector2',
    intro: 'test 2',
  },
  {
    element: '.selector3',
    intro: 'test 3',
  },
];

const hints = [
  {
    element: '.selector1',
    hint: 'test 1',
    hintPosition: 'middle-middle',
  },
  {
    element: '.selector2',
    hint: 'test 2',
  },
];*/

export default class Dashboard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            category: "My Programs",
            all_mktplc_programs: [],
            my_programs:         [],  // trainer based programs
            my_mktplc_programs:  [],
            checkProgramsFlag:   false,
            programSubscribed: false,
            dashboardProgramId: 2,
            showModalMktplcInfo: false,

            // Product Tour //
            stepsEnabled: false,
            initialStep: 0,
            steps: [
                {
                  element: ".dropdownStepsTour",
                  intro: "View programs you joined or add more programs through the dashboard.",
                  position: 'left'
              },
                {
                  element: ".programBoxTour",
                  intro: "All of the programs you joined are located here. Click on an image to begin the workout program.",
                  position: 'auto'
                }
            ],
            // Dashboard Tour //
            stepsEnabledDashboard: false,
            initialStepDashboard: 0,
            stepsDashboard: [
                {
                  element: ".dropdownStepsDashboardTour",
                  intro: "View all free programs or see the programs you've joined.",
                  position: 'left'
              },
                {
                  element: ".dashboardCardsTour",
                  intro: "All free workout programs are listed here. Click on an image to view a program's details and if you like it, subscribe for free.",
                  position: 'top'
                }
            ],
            //hintsEnabled: true,
            /*hints: [
                {
                  element: ".hello",
                  hint: "Hello hint",
                  hintPosition: "middle-right"
                }
            ]*/
        }
    }

    componentDidMount() {

        var user_id = this.props.globalUserId;

        if (!this.props.isAuthenticated)
            return;

        if(user_id == "null")
            this.props.handleLogout();

        try {
            this.renderProgramList(user_id);

            ////   If the Program Summary is to be reviewed from a PH user, automatically   ////
            ////   display the marketplace and show the appropriate program summary modal   ////
            if(mktplc_prog_id != undefined)
                this.gotoAthleteMktplace();

        } catch (e) {
              alert(e);
        }

        this.setState({ isLoading: false });
    }

    async renderProgramList(user_id) {

        var results = await invokeGetListAllPrograms(user_id);

        if(results.status) {
            this.setState({
                my_programs:                results.data.my_programs,
                my_mktplc_programs:         results.data.my_marketplace_programs,
                completed_days_per_program: results.data.completed_days_per_program,
                checkProgramsFlag: true     // the server has been checked for programs
            })
        }/* */
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

            /*for(var key in prevProps) {
                console.log("key: " + key);
                console.log("prevProps: " + prevProps[key]);
            }*/
            var stepsEnabled = this.state.stepsEnabled;
            //console.log("showHelpTour prevProps: " + prevProps["showHelpTour"]);
            //console.log("stepsEnabled prevProps: " + stepsEnabled);
            //!prevProps["showHelpTour"] &&
            // Don't show help tour //
            /*if(!prevProps["showHelpTour"] && !stepsEnabled) {
                console.log("1.");
                //this.setState(() => ({ stepsEnabled: true }));
                //this.setState(() => ({ stepsEnabledDashboard: true }));
            } else if (stepsEnabled){
                console.log("2.");
                this.setState(() => ({ stepsEnabled: true }));
            } else {
                this.setState(() => ({ stepsEnabled: null }));
            }*/
    }

    getProgramDropdown = async(id, name) => {

        var user_id  = this.props.globalUserId;
        var results  = [];
        var results2 = false;

        // id: 1 = all programs
        // id: 2 = my programs

        if(id == 1)
            results2 = await invokeGetListAllMarketplacePrograms(user_id);
        else
            results = await invokeGetListAllPrograms(user_id);

        if(results2.status)
            this.setState({
                all_mktplc_programs: results2.data.all_marketplace_programs,
                dashboardProgramId: id,
                category: name
            })
        else if(results.status)
            this.setState({
                my_programs: results.data.my_programs,
                my_mktplc_programs: results.data.my_marketplace_programs,
                completed_days_per_program: results.data.completed_days_per_program,
                dashboardProgramId: id,
                category: name
            })
        else
            this.setState({
                dashboardProgramId: id,
                category: name
            })

    }

    handleSubscribeToMktplcProgram = async (program_id, program_mktplc_id) => {

        var user_id = this.props.globalUserId;
        /*console.log("*** handleSubscribeToMktplcProgram ***");
        console.log("QA user_id: " + user_id);
        console.log("QA program_id: " + program_id);
        console.log("QA program_mktplc_id: " + program_mktplc_id);*/

        var results = await invokeSetAthleteMarketplaceSubscriber(user_id, program_id, program_mktplc_id)

        if(results.status) {
            // Tell modal to Close
            this.setState({
                programSubscribed: true,
                showModalMktplcInfo: true // show "Congrats Subscription" Modal
            });

            // Tell modal it's ok to Open again
            this.setState({ programSubscribed: false });
        } else
            alert("sorry, there was a problem subscribing you to the program.")
    }

    gotoAthleteMktplace = async event => {
        var user_id  = this.props.globalUserId;
        var results2 = await invokeGetListAllMarketplacePrograms(user_id);
        var id       = 1;
        var name     = "Dashboard";

        if(results2.status)
            this.setState({
                all_mktplc_programs: results2.data.all_marketplace_programs,
                dashboardProgramId: id,
                category: name
            })
    }


    showPTTypeformScreen = () => {
        var company_id        = localStorage.getItem('globalUserCompanyId');
        //if(company_id == posture_health_company_id)
        window.open("https://acceleratesp.typeform.com/to/ZHrlsqSQ", '_blank');
    }

    showFitnessTypeformScreen = () => {
        var company_id        = localStorage.getItem('globalUserCompanyId');
        window.open("https://acceleratesp.typeform.com/to/auRJGg4I", '_blank');
    }

    getMyPrograms = () => {

        var ctr = 0;
        var cards = true;
        var row_arr =[];
        var company_id        = localStorage.getItem('globalUserCompanyId');
        var user_id           = localStorage.getItem('globalUserId');

        var completed_days_per_program = this.state.completed_days_per_program;
        var dashboard_program_id       = this.state.dashboardProgramId;
        var my_programs                = this.state.my_programs; // trainer based programs
        var my_mktplc_programs         = this.state.my_mktplc_programs;
        var all_mktplc_programs        = this.state.all_mktplc_programs;
        var my_programs_lgth           = my_programs.length;
        var all_mktplc_lgth            = all_mktplc_programs.length;
        var my_mktplc_programs_lgth    = my_mktplc_programs.length;

        //////////////////////////////////////////////
        ////   SHOW ALL PROGRAMS in MARKETPLACE   ////
        //////////////////////////////////////////////
        //console.log("dashboard_program_id: " + dashboard_program_id);
        if(dashboard_program_id == 1 ) { //}|| mktplc_prog_id != undefined) {
                for(var a = 0; a < all_mktplc_lgth; a++) {
                        var program_name      = all_mktplc_programs[a].name;
                        var program_id        = all_mktplc_programs[a].program_id;
                        var program_mktplc_id = all_mktplc_programs[a].mktplc_id;

                        var cover_image = <img src={require('../../images/cards/cover/cover1.jpg')} className="dashboardCoverImage"/>
                        /*console.log("--------------------------------------------");
                        console.log("program_name: " + program_name);
                        console.log("program_mktplc_id: " + program_mktplc_id);
                        console.log("program_id: " + program_id);*/

                        var row =  <div key={ uniqueId()}
                                        className="programBoxTour"
                                        style={{maxWidth:"100%", position:"relative", left:"0px",height:"310px", border:"3px solid black"}}>
                                        <span className="programCard"
                                              //href={`/ProgramBegin/${program_id}/${program_name}/0` /*/${summary_id}*/ }
                                              onClick={this.handleSubscribeToMktplcProgram.bind(this, program_id, program_mktplc_id)}
                                              style={{position:"relative", top:0, cursor: "pointer"}}>
                                                <span className="dashboardImageFade"></span>
                                                <div className="dashboardContainer">

                                                    <span className="rowCardTitleOnlyContainer">
                                                        <span className="rowCardTitleOnly">
                                                             { program_name }
                                                        </span>
                                                    </span>
                                                    <span className="dashboardTextContainer"></span>

                                                    { cover_image }

                                                </div>
                                        </span>
                                    </div>
                         row_arr.push(row);
                }

        } else { // mktplc_prog_id comes from PH when a user selects a program to preview

        ///////////////////////////////////////////
        ////    SHOW ONLY ATHLETE PROGRAMS     ////
        ///////////////////////////////////////////
                for(var m = 0; m < my_programs_lgth; m++) {
                    var program_id    = my_programs[m][0];
                    var summary_id    = '001';
                    var program_name  = my_programs[m][1];
                    var template_id   = my_programs[m][2]; // used for challenges; tracks which templates and program_ids are part of the challenge

                    //// Get Percent of Programs Completed ////
                    var program_percent_completed = 0/100;

                    for(var key2 in completed_days_per_program) {
                        var tmp_program_id     = completed_days_per_program[key2][0];
                        var tmp_percent_filled = completed_days_per_program[key2][1];

                        if(tmp_program_id === program_id) {
                            program_percent_completed = tmp_percent_filled * 100;
                            //console.log("program % completed: " + program_percent_completed);
                        }
                    }

                    var challenge_icon = "" ;
                    /* temp hold since we are not using challenges rightt now
                    if(template_id != null) challenge_icon = <span  className = "dashboardChallengeIconBox"
                                                                    href={`/Challenge/${template_id}` }
                                                                    onClick={this.handleProgrmClic-k}>
                                                                    <FontAwesomeIcon icon="medal"
                                                                                     href={`/Challenge/${template_id}`}
                                                                                     onClick={this.handleProgrmClic-k} />
                                                             </span>*/

                    var tmp_img = "cover2.jpg";
                    if(m == 1 || m == 7 || m == 13) tmp_img       = "cover3.jpg";
                    else if(m == 2 || m == 8 || m == 14) tmp_img  = "cover1.jpg";
                    else if(m == 3 || m == 9 || m == 15) tmp_img  = "cover4.jpg";
                    else if(m == 4 || m == 10 || m == 16) tmp_img = "cover7.jpg";
                    else if(m == 5 || m == 11 || m == 17) tmp_img = "cover6.jpg";
                    else if(m == 6 || m == 12 || m == 18) tmp_img = "cover5.jpg";

                    var img_src = '../../images/cards/cover/'+tmp_img;
                    var cover_image = <img src={require('../../images/cards/cover/'+tmp_img)} className="dashboardCoverImage"/>
                    var url = `/ProgramBegin/${program_id}/${program_name}/0`;


                    var row =  <div key={ uniqueId()}
                                    className=""
                                    style={{maxWidth:"100%", position:"relative", top: "-110px", left:"0px",height:"310px", border:"0px solid black"}}>

                                    <span className="programCard"
                                          onClick={this.handleProgrmClick.bind(this, tmp_img, url, 0)}
                                          style={{position:"relative", top: 0}}>

                                            <CardProgressBar percentText={program_percent_completed} width={program_percent_completed} />

                                            <span className="dashboardImageFade"></span>
                                            <div className="dashboardContainer">

                                                <span className="rowCardTitleOnlyContainer">
                                                    <span className="rowCardTitleOnly">
                                                        { program_name }
                                                    </span>
                                                </span>
                                                { challenge_icon }
                                                <span className="dashboardTextContainer"></span>

                                                { cover_image }

                                            </div>
                                    </span>
                                </div>
                     row_arr.push(row);

                     ctr++;
                }

                // CHECK IF ATHLETE SUBSCRIBED TO ANY MARKETPLACE PROGRAMS //
                for(var mk = 0; mk < my_mktplc_programs_lgth; mk++) {
                        var mktplc_program_id     = my_mktplc_programs[mk].program_marketplace_id;
                        var subscriber_program_id = my_mktplc_programs[mk].subscriber_program_id; //program_id;
                        var program_name          = my_mktplc_programs[mk].name;
                        var program_image         = my_mktplc_programs[mk].program_image;
                        var img_src               = this.getCoverImageURL(program_image);
                        var url = `/ProgramBegin/${subscriber_program_id}/${program_name}/${mktplc_program_id}`;

                        //// This is a temporary solution until there are more yoga programs,
                        //// all the UIDs need to be pulled from the program_athlete_marketplace table
                        //// This tracks which programs are yoga based and sends the user to a different video player

                        if(mktplc_program_id === "86e9d09b-671a-4715-b78a-5fcb1ad634d0" || mktplc_program_id === "59d07e8c-9be5-4eae-a8f9-3c86686a513b" ||
                           mktplc_program_id === "e48cc8c4-828d-47b8-a67e-54137c0e0af3" || mktplc_program_id === "8d7fbc36-9352-4e9e-9d8e-fad33de51b34") {
                                                  url = '/youtubeplayer/'+subscriber_program_id;
                                                  ///:video_id/:yt_id
                        }


                        var cover_image = <img src={require('../../images/cards/cover/cover1.jpg')} className="dashboardCoverImage"/>

                        if(program_image != undefined)
                            cover_image = <img src={img_src} className="dashboardCoverImage"/>; // <img src={require("../../images/program/"+program_image)} className="dashboardCoverImage"/>

                        /* * /
                        console.log("---------------------------------");
                        console.log("program_name: " + program_name);
                        console.log("mktplc_program_id: " + mktplc_program_id);
                        console.log("subscriber_program_id: " + subscriber_program_id);
                        console.log("img_src: " + img_src);
                        console.log("url: " + url);/* */

                        var row =  <div key={ uniqueId()}
                                        className=""
                                        style={{maxWidth:"100%", position:"relative", top: "-90px", left:"0px",height:"310px", border:"0px solid black", backgroundColor: "#bbb"}}>
                                        <span className="programCard"
                                              onClick={this.handleProgrmClick.bind(this, program_image, url, mktplc_program_id)}
                                              style={{position:"relative", top:0, cursor: "pointer"}}>
                                                { /* }<CardProgressBar percentText={program_percent_completed} width={program_percent_completed} />*/ }
                                                <span className="dashboardImageFade"></span>
                                                <div className="dashboardContainer">
                                                    <span className="rowCardTitleOnlyContainer">
                                                        <span className="rowCardTitleOnly">
                                                            { program_name }
                                                        </span>
                                                        <div style = {{float: "left", position: "relative", top: 253, left: 46, paddingRight: 20, color: "#fff", zIndex: 11000}}>
                                                            <LoaderButton
                                                                className = ""
                                                                bsSize    = "large"
                                                                width     = "135px"
                                                                height    = "31px"
                                                                fontSize  = "15px"
                                                                btncolor  = {MainColor}
                                                                type      = "submit"
                                                                isLoading = {this.state.isLoading}
                                                                text      = "Begin Program"
                                                                loadingText = "Loading..."
                                                              />
                                                         </div>
                                                    </span>
                                                    { challenge_icon }
                                                    <span className="dashboardTextContainer"></span>
                                                    { cover_image }
                                                </div>
                                        </span>
                                    </div>

                         row_arr.push(row);
                }

                if(company_id === posture_health_company_id || user_id === klu_user_id || user_id === jc_user_id) {
                    var custom_text = "Are you looking for customized physical therapy, fitness, or performance training? Do you have injuries, specific goals, or need more guidance?  Get in touch with our team of highly specialized professionals."
                    row_arr.push(<div key={ uniqueId()}>
                                    <br/>
                                    <div style={{marginLeft:15, fontSize:18}}>{custom_text}</div>
                                    <br/>
                                    <div style={{marginLeft:15, fontSize:18, textAlign:"center"}}>
                                        <Button className   = "dropdownGeneral"
                                                id          = "dropdown-size-large"

                                                onClick    = {() => this.showPTTypeformScreen()}>
                                                    Physical Therapy
                                        </Button>
                                        <span style={{display:"inline-block", width: 30}}></span>
                                        <Button className   = "dropdownGeneral"
                                                id          = "dropdown-size-large"

                                                onClick    = {() => this.showFitnessTypeformScreen()}>
                                                    Fitness or Performance Training
                                        </Button>
                                    </div>
                                 </div>
                                )
                }

                //this.handleProgrmClick.bind(this, program_image, url, mktplc_program_id)


                ////  If user has 0 programs, link to the Athlete Marketplace  ////
                var marketplace_text;

                if(company_id === posture_health_company_id || user_id === klu_user_id || user_id === jc_user_id) {
                        marketplace_text = <span>
                                               <span onClick={this.gotoAthleteMktplace}>
                                                    To subscribe to a program, visit our
                                                    <span style={{cursor: "pointer", color: LinkColor}}> <b>program marketplace</b></span>.
                                               </span>
                                               <br/><br/><br/><br/>
                                               <div>
                                                   If you have programs but they're not showing up, try <span onClick={this.props.handleLogout} style={{cursor: "pointer", color: LinkColor}}>refreshing the page</span>.
                                               </div>
                                           </span>
                }

                var panel = <div>
                                <div style={{padding:20, paddingTop: 50, fontSize:22}}>
                                    It doesn't look like you have any programs yet.<br/><br/>
                                    { marketplace_text }
                                </div>
                            </div>
        } // end My Programs If..

        //console.log(">> mktplc_prog_id: " + mktplc_prog_id);

        if((my_programs_lgth > 0 || my_mktplc_programs_lgth > 0) && dashboard_program_id != 1){  // || mktplc_prog_id != undefined) {
                var program_dropdown;
                if(company_id == posture_health_company_id || user_id == klu_user_id || user_id === jc_user_id) {

                    program_dropdown =  <div className="myProgramsDropdownContainer">
                                            <div className="dropdownStepsTour">
                                                <DropdownHome
                                                    category  = {this.state.category}
                                                    getProgramDropdown={this.getProgramDropdown}
                                                />
                                            </div>
                                        </div>

                }

                panel = <div key={ uniqueId() }
                             className=""
                             style={{border:"0px solid black"}}>
                             { program_dropdown }
                             <div className="myProgramRow">
                                 <Row className="clearfix" style={{border:"0px solid red"}}>
                                     <Col xs={12} sm={12} md={12} lg={12}>
                                      { row_arr }
                                    </Col>
                                 </Row>
                             </div>
                        </div>

        } else if(dashboard_program_id == 1) {
                //console.log("Dashboard mktplc_prog_id: " + mktplc_prog_id);
                panel = <div>
                            <div className="myProgramsDropdownContainer">
                                <div className="dropdownStepsDashboardTour">
                                    <DropdownHome
                                        category  = {this.state.category}
                                        getProgramDropdown={this.getProgramDropdown}
                                    />
                                </div>
                            </div>
                            <div>
                            <AthleteMarketplace programSubscribed              = {this.state.programSubscribed}
                                                handlePrivacyToS               = {this.handlePrivacyToS}
                                                allMktplcPrograms              = {this.state.all_mktplc_programs}
                                                presetProgramId                = {mktplc_prog_id /*"25bf7a60-9c94-11ea-826f-89faa507940c"*/}
                                                handleSubscribeToMktplcProgram = {this.handleSubscribeToMktplcProgram}/>
                            </div>
                        </div>
        } else {
                ////////////////////////////////////////////////////////////
                ////  Show Athlete Marketplace ONLY for POSTURE HEALTH  ////
                if(company_id == posture_health_company_id || user_id == klu_user_id || user_id === jc_user_id) {
                    // if there are no programs in My Programs, then go straight to the marketplace

                    if(my_programs_lgth == 0 && dashboard_program_id != 1 && this.state.checkProgramsFlag) {
                        this.gotoAthleteMktplace();
                    }
                }
        }

        return panel;
    }



    handlePrivacyToS = (event) => {
        var href = event.currentTarget.getAttribute("href");
        console.log("href: " + href);
        this.props.history.push(href);
    }

    renderProgramsList() {
        var programs  = [];
        var tmp_name;

        return this.getMyPrograms();
    }

    handleProgrmClick = (img_src, url, mktplc_program_id) => {
        //event.preventDefault();
        var company_id = localStorage.getItem('globalUserCompanyId');

        ////  Store Athlete Marketplace Id for later use ////
        ////  Can't add mktplace id to URL query string  ////
        localStorage.setItem('athleteMarketplaceId', mktplc_program_id);

        var id =  this.state.dashboardProgramId;
        var custom_cover_image  = cover_image_custom_url + img_src;
        var general_cover_image = cover_image_general_url + img_src;
        // id: 1 = Posture Health athlete marketplace
        // id: 2 = Generic images on dashboard
        if(company_id == posture_health_company_id)
            this.props.setCoverImage(custom_cover_image); // URL used for Posture Health Mktplc
        else
            this.props.setCoverImage(general_cover_image); // URL for generic dashboard cover images

        this.props.history.push(url); //(event.currentTarget.getAttribute("href"));
    }

    getCoverImageURL = (img_src) => {
        var company_id = localStorage.getItem('globalUserCompanyId');
        var custom_cover_image  = cover_image_custom_url + img_src;
        var general_cover_image = cover_image_general_url + img_src;
        var image = general_cover_image;
        // id: 1 = Posture Health athlete marketplace
        // id: 2 = Generic images on dashboard
        if(company_id == posture_health_company_id)
            image = custom_cover_image;

        return image;
    }

    renderLander() {
        return (
            <div className="lander">
                <h1>TS</h1>
            </div>
        );
    }

    renderList() {
        return (
            <div className="mainDashboardContainer">
                    <span className = "dashboardMainIconHelpTour0 glyphicon glyphicon-question-sign"
                          onClick   = {this.showHelpTour}/>
                    {!this.state.isLoading && this.renderProgramsList()}
            </div>
        );
    }

    ///////  BEGIN: PRODUCT TOUR  //////
    onExit = () => {
        this.setState(() => ({ stepsEnabled: false,  stepsEnabledDashboard: false }));
    };
    ///////  END: PRODUCT TOUR  //////

    showHelpTour = () => {
            var screen = this.state.category;

            //this.setState(prevState => ({ stepsEnabled: !prevState.stepsEnabled }));
            /*const newStep = {
              element: ".none",
              intro: "That's it for the welcome tour!"
            };
            //this.setState(prevState => ({ steps: [...prevState.steps, newStep], stepsEnabled: true }));/* */

            if(screen === "My Programs")
                this.setState(() => ({ stepsEnabled: true }));
            else
                this.setState(() => ({ stepsEnabledDashboard: true }));
    }

    render() {
        let closeModalMktplcInfo = () => this.setState({ showModalMktplcInfo: false }); //close simple modal window
        const {
          stepsEnabled,
          stepsEnabledDashboard,
          steps,
          stepsDashboard,
          initialStep,
          initialStepDashboard,
          hintsEnabled,
          hints
        } = this.state;

        //var showHelpTour = this.props.showHelpTour;
        //console.log("showHelpTour: " + showHelpTour);
        //if(showHelpTour) this.showHelpTour();

        return (
          <div className="HomeProgram_old" style={{display:"inline-block", minHeight: "800px", width: "100%", position:"relative", top:25, backgroundColor:"#efefef",border:"0px solid black"}}>

                { this.props.isAuthenticated ? this.renderList() : this.renderLander() }
                <ModalMktplcInfo
                        show          = { this.state.showModalMktplcInfo }
                        onHide        = { closeModalMktplcInfo }
                        getProgramDropdown = {this.getProgramDropdown}
                />

                <Steps
                    enabled={stepsEnabled}
                    steps={steps}
                    initialStep={initialStep}
                    onExit={this.onExit}
                    options= {{disableInteraction:true}}
                />
                <Steps
                    enabled={stepsEnabledDashboard}
                    steps={stepsDashboard}
                    initialStep={initialStepDashboard}
                    onExit={this.onExit}
                    options= {{
                        disableInteraction:true,
                        skipLabel: "Exit"}}
                />
          </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/program/Dashboard.js